import { __awaiter, __decorate, __extends, __generator } from "tslib";
// import Vue from 'vue'
// import Component from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator';
import { QuestionCandidateApi, AnswerApi, EntryApi, } from '../apis';
var questionCandidateApi = new QuestionCandidateApi(undefined);
var answerApi = new AnswerApi(undefined);
var entryApi = new EntryApi(undefined);
var QuestionPage = /** @class */ (function (_super) {
    __extends(QuestionPage, _super);
    function QuestionPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.survey = null;
        _this.questionCandidate = null;
        _this.appType = '';
        _this.clickedFlag = false;
        return _this;
    }
    QuestionPage.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.survey = this.$store.state.survey;
                        this.appType = this.$store.state.appType;
                        _a = this;
                        return [4 /*yield*/, questionCandidateApi.getQuestionCandidate(this.$store.state.nextQuestionID).then(function (res) { return res.data; })];
                    case 1:
                        _a.questionCandidate = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(QuestionPage.prototype, "classes", {
        get: function () {
            return {
                'diag-answer-button': true
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionPage.prototype, "answerFontSize", {
        get: function () {
            var fontSize = '1.2rem';
            if (this.questionCandidate && this.questionCandidate.inputType) {
                if (this.questionCandidate.inputType.indexOf('rem') >= 0) {
                    fontSize = this.questionCandidate.inputType;
                }
            }
            return fontSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionPage.prototype, "styles", {
        get: function () {
            if (this.survey && this.survey.mainColor) {
                // alert(`mainColor: ${this.survey.mainColor}`)
            }
            else {
                // alert(`mainColor is empty`)
            }
            return {
                '--color': (this.survey && this.survey.mainColor) ? this.survey.mainColor : 'green'
            };
        },
        enumerable: false,
        configurable: true
    });
    QuestionPage.prototype.next = function (answerCandidate) {
        return __awaiter(this, void 0, void 0, function () {
            var entry, answerRequest, answer, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.clickedFlag = true;
                        entry = this.$store.state.entry;
                        if (!entry.id) {
                            console.error('entry id is null');
                            return [2 /*return*/];
                        }
                        if (!this.questionCandidate) {
                            console.error('questionCandidate id is null');
                            return [2 /*return*/];
                        }
                        if (!answerCandidate) {
                            console.error('answerCandidate id is null');
                            return [2 /*return*/];
                        }
                        answerRequest = {
                            entryID: entry.id,
                            questionCandidateID: this.questionCandidate.id,
                            answerNo: answerCandidate.answerNo
                        };
                        return [4 /*yield*/, answerApi.createAnswer(answerRequest).then(function (res) { return res.data; })];
                    case 1:
                        answer = _b.sent();
                        if (!answer.finishFlag) return [3 /*break*/, 3];
                        return [4 /*yield*/, entryApi.getEntry(entry.id).then(function (res) { return res.data; })];
                    case 2:
                        entry = _b.sent();
                        this.$store.commit('setResultID', { resultID: entry.resultID });
                        if (this.appType === 'LINE') {
                            this.$emit('end');
                        }
                        else {
                            this.$emit('mail');
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        if (!answer.nextQuestionID) {
                            return [2 /*return*/];
                        }
                        this.$store.commit('setNextQuestionID', { nextQuestionID: answer.nextQuestionID });
                        _a = this;
                        return [4 /*yield*/, questionCandidateApi.getQuestionCandidate(answer.nextQuestionID).then(function (res) { return res.data; })];
                    case 4:
                        _a.questionCandidate = _b.sent();
                        _b.label = 5;
                    case 5:
                        this.clickedFlag = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    QuestionPage = __decorate([
        Component({})
    ], QuestionPage);
    return QuestionPage;
}(Vue));
export default QuestionPage;
